export function formatVoiceDurationSec(sec) {
  if (sec == null || sec === "") return null;
  const n = typeof sec === "number" ? sec : Number(sec);
  if (!Number.isFinite(n) || n < 0) return null;
  if (n === 0) return "0s";
  if (n < 60) return `${Math.round(n)}s`;
  const m = Math.floor(n / 60);
  const s = Math.round(n % 60);
  return s ? `${m}min ${s}s` : `${m}min`;
}

export function resolveAttendedMode(voice) {
  const m = String(voice?.attendedMode || "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_");
  if (m) return m;
  if (voice?.bridgeMode === "click_to_call" || Number(voice?.legs) === 2) return "click_to_call";
  return null;
}

export function voiceCallTitleIsViewer({
  actorUserId = 0,
  currentUserId = 0,
  actorUserName = "",
} = {}) {
  const actor = Number(actorUserId) || 0;
  const viewer = Number(currentUserId) || 0;
  const name = String(actorUserName || "").trim();
  if (actor > 0 && viewer > 0) return actor === viewer;
  if (name || actor > 0) return false;
  return true;
}

export function resolveVoiceCallTitleKey(voice, outbound, { isYou = true } = {}) {
  const mode = resolveAttendedMode(voice);
  switch (mode) {
    case "queue_claim":
      return isYou ? "voiceCall.queueClaimTitle" : "voiceCall.userQueueClaimTitle";
    case "queue_auto":
      return "voiceCall.queueAutoTitle";
    case "live_join":
      return isYou ? "voiceCall.liveJoinTitle" : "voiceCall.userLiveJoinTitle";
    case "inbound_answer":
      return isYou ? "voiceCall.inboundAnswerTitle" : "voiceCall.userInboundAnswerTitle";
    case "click_to_call":
      return isYou ? "voiceCall.clickToCallTitle" : "voiceCall.userClickToCallTitle";
    default:
      if (!outbound) return "voiceCall.inboundTitle";
      return isYou ? "voiceCall.youCalledTitle" : "voiceCall.userCalledTitle";
  }
}

export function showVoiceCallAsInbound(voice, outbound) {
  const mode = resolveAttendedMode(voice);
  return (
    !outbound ||
    mode === "queue_claim" ||
    mode === "queue_auto" ||
    mode === "inbound_answer" ||
    mode === "live_join"
  );
}

export function resolveVoiceOutcome(voice, outcomeI18n = {}) {
  const raw = String(voice?.answerOutcome || "")
    .toLowerCase()
    .replace(/-/g, "_");
  if (outcomeI18n[raw] || raw === "mailbox") return raw || null;
  const st = String(voice?.status || "").toLowerCase();
  if (st === "rejected") return "rejected";
  if (st === "technical-drop" || st === "technical_drop") return "technical_drop";
  if (st === "no-answer") return "no_answer";
  if (st === "busy") return "busy";
  if (st === "failed") return "failed";
  if (st === "canceled" || st === "cancelled") return "canceled";
  if (st === "answered") return "answered";
  if (st === "mailbox") return "mailbox";
  return null;
}

const LIVE_STATUSES = new Set([
  "initiated",
  "ringing",
  "queued",
  "in-progress",
  "answered",
]);

export function isLiveVoiceCall(voice, outcomeI18n = {}) {
  const outcome = resolveVoiceOutcome(voice, outcomeI18n);
  if (
    outcome === "mailbox" ||
    outcome === "no_answer" ||
    outcome === "failed" ||
    outcome === "rejected"
  ) {
    return false;
  }
  return LIVE_STATUSES.has(String(voice?.status || "").toLowerCase());
}
